<template>
<div :style="style">
    <Affix>
     <div ref="toolbar">
    <div  v-if="showMenuToolbar" style="background:#eee;padding-bottom: 5px;">
    <Card :padding="0"  dis-hover>
        <Row type="flex" justify="start" align="middle"  style="padding:5px 10px" >
            <ButtonToolBar ref="menutoolbar" :config="menuToolbar"  :moduleMethod="moduleMethod" :ignoreModule="ignoreModule"  @doAction="doAction"/>
        </Row>
    </Card>
    </div>
    </div>
    </Affix>
    <Card  :padding="0" :bordered="false" style="background:#eee;"  dis-hover>
           <Row type="flex" justify="start"  :gutter="rowGutter" :style="style2">
            <Col  :span="formCol">
                <div ref="title" >
                <Card v-if="showBillTitle" :bordered="false" :padding="0" style="margin-bottom: 10px;padding: 16px 10px;" dis-hover>
                   <Row type="flex" justify="start" align="middle" :gutter="0" >
                        <Col span='6'>
                            <Row type="flex" justify="start" align="middle" :gutter="4" >
                                <Col><span class="efuture-title-font-2" v-text="myConfig.billnoText" /></Col> <Col><span class="efuture-title-font-2" v-text="billno" /></Col>
                             </Row>
                         </Col>
                         <Col span='18' >
                            <Row type="flex" justify="end" align="middle" :gutter="16">
                                 <Col v-if="false"><span class="efuture-title-font-1" v-text="myConfig.billstatusText" /></Col> <Col><span class="efuture-title-font-2" v-text="billstatus" /></Col>
                            </Row>
                         </Col>
                    </Row>
                </Card>
                </div>
                <FormCardGroupBox  id="head"  v-if="multipleForm"  ref="form"  :config="myConfig.formsConfig" :dictData="dictData" @doAction="doAction"/>
                <FormCardBox  v-else  id="head" ref="form"  style="margin-bottom: 10px;" :config="singleForm" :dictData="dictData" @doAction="doAction"/>
                <div v-for="(temp2,index) in detailConfig.items"  v-show="detailVisible[index].visible"  style="margin-bottom: 10px;">
                    <EditGridCard  v-if="temp2.type === 'EditGridCard'" :ref="temp2.name" :id="'detail_'+index" :config="temp2" :dictData="dictData" @doAction="doAction"/>
                    <DetailsBox  v-if="temp2.type === 'DetailsBox'" :ref="temp2.name"  :id="'detail_'+index" :config="temp2" :dictData="dictData" @doAction="doAction"/>
                    <FormCardBox  v-if="temp2.type === 'FormCardBox'" :ref="temp2.name"  :id="'detail_'+index" :config="temp2" :dictData="dictData"/>
                    <AppendixBox  v-if="temp2.type === 'AppendixBox'" :ref="temp2.name"  :id="'detail_'+index" :config="temp2" :modulecode="billmoduleid" @doAction="doAction"/>
                </div>
                <div  v-if="myConfig.showOperLog"   v-show="operVisible" id="operlog" style="margin-bottom: 10px;">
                    <OperLog  ref="operlog" :config="myConfig"/>
                </div>
                <div  v-if="myConfig.showApprovalLog"   v-show="approvalVisible"  id="approvallog" style="margin-bottom: 10px;">
                    <ApprovalLog  ref="approvallog" :config="myConfig.approvalConfig"/>
                </div>
                <Row v-if="myConfig.showRowBtn" v-show="rowBtnVisible">
                    <Button type="dashed" style="background-color:#f8f8f9" @click="doRowBtn" long >{{myConfig.rowBtnName}}</Button>
                </Row>
            </Col>
            <Col v-if="showAnchorLink" :span="anchorCol" style="background-color:#fff">
                   <Anchor  class="efutre-anchor" :offset-top="offsetTop" show-ink @on-change="anchorClick">
                        <AnchorLink v-for="temp in anchorData" :href="temp.id"  v-show="temp.visible" :title="temp.name" style="margin:5px" @click="anchorClick(temp.id)"/>
                   </Anchor>
            </Col>
        </Row>
    </Card>
     <Modal v-if="showDetailsGroup" class="efuture-model" v-model="editFlag" fullscreen :closable="false">
            <div v-for="temp in detailsGroup"  v-show="temp.code === curlDetailsGroup" :id="'detailsGroup_'+temp.code" >
                <DetailsBox  v-for="temp2 in temp.items" :ref="temp2.name+'_detailsGroup'"   :config="temp2" :dictData="dictData" @doAction="doAction"/>
             </div>
             <Row slot="footer" type="flex" justify="center" align="middle" style="margin-top: 10px;margin-bottom: 10px;" :gutter="16">
                <Col>
                    <Button  type="primary" @click="saveDetailsGroup">保存</Button>
                    <Button  style="margin-left: 20px;" @click="cancelDetailsGroup">放弃</Button>
                </Col>
            </Row>
    </Modal>
    
</div>
</template>
<script>
import QuickQueryToolbar from './quickquerytoolbar.vue';
import PromptMessage from './promptmessage.vue';
import ButtonToolbar from './btntoolbar.vue';
import OperLog from './operlog.vue';
import ApprovalLog from './approvalbox.vue';
import elementResizeDetectorMaker from 'element-resize-detector';
export default {
    name:'billdetailform',
    components:{QuickQueryToolbar,PromptMessage,ButtonToolbar,OperLog,ApprovalLog},
    data () {
        return {
            curlEditObject:'',
            title:'详情',
            billno:'',
            billstatus:'',
            multipleForm:false,
            showMenuToolbar:true,
            showBillTitle:true,
            showOperLog:true,
            singleForm:{},
            readOnly:false,
            showAnchorLink:false,
            operVisible:true,
            approvalVisible:true,
            rowBtnVisible:false,
            showDetailsGroup:false,
            anchorData:[],
            rowGutter:16,
            anchorCol:4,
            formCol:20,
            myConfig:{
                saveModel:'whole', // whole整体保存，part局部
                adjustHeight:160,
                titleType:1,
                detailsGroupName:'编辑',
                billnoText:'单据编号',
                billnoField:'billno',
                billstatusField:'billstatus',
                billstatusText:'单据状态',
                billstatusDictkey:'billstatus',
                showRowBtn:false,
                rowBtnName:'继续录入',
                rowBtnMethod:'',
                showApprovalLog:false,
                approvalConfig:{}
            },
            detailVisible:[],
            menuToolbar:{

            },
            detailsGroup:[],
            curlDetailsGroup:'',
            detailConfig:{},
            offsetTop: 0,
            editFlag:false,
            frontBtn:[{
                name:'backData',text:'返回'
            }, {
                name:'preBill',text:'上一单'
            },{
                name:'nextBill',text:'下一单'
            }],
            ignoreModule:['backData','preBill','nextBill'],
            extraHeight:0,
            outsideHeight:0
        };
    },
    created () {
        this.myConfig = Object.assign({}, this.myConfig, this.config);
        if (this.myConfig.formsConfig.items.length  === 1) {
            Object.assign(this.singleForm , this.myConfig.formsConfig.items[0]);
            if (this.myConfig.title !== undefined) {
                if (this.singleForm.title === undefined) {
                    this.singleForm.title = this.myConfig.title;
                }
                if (this.singleForm.title  === undefined) {
                    this.singleForm.title = this.title;
                } 
            } else {
                if (this.singleForm.title  === undefined) {
                    this.singleForm.title = this.title;
                } 
            }
            if (this.myConfig.saveModel === 'part') {
                this.singleForm.showBtn = true;
                this.singleForm.editObjectBefore = this.editObjectBefore;
            }  else {
                this.singleForm.showBtn = false;
            }
            this.singleForm.hide = false;
            this.singleForm.disHover = false;
            this.singleForm.titleType = this.myConfig.titleType;
            this.anchorData.push({id:'#head',name: this.singleForm.title,visible:true});
        } else if (this.myConfig.formsConfig.items.length  > 1){
            if (this.myConfig.formsConfig.title === undefined) {
                this.myConfig.formsConfig.title = this.title;
            }
            this.multipleForm = true;
            this.myConfig.formsConfig.title = '';
            this.myConfig.formsConfig.showBtn = false;
            this.myConfig.formsConfig.disHover = false;
            this.myConfig.formsConfig.items.forEach((el, index) => {
                if (el.name === undefined) {
                    el.name = 'headForm_' + index; 
                }
                el.titleType = Number(this.myConfig.titleType) + 1;
                if (this.myConfig.saveModel === 'part') {
                    el.showBtn = true;
                    el.editObjectBefore = this.editObjectBefore;
                }  else {
                    el.showBtn = false;
                }
                this.anchorData.push({id:'#'+el.name ,name:el.title,visible:true});
            });
        }
       
        if (this.myConfig.showMenuToolbar !== undefined) {
            this.showMenuToolbar = this.config.showMenuToolbar;
        }
       
       
        if (this.myConfig.showBillTitle !== undefined) {
            this.showBillTitle = this.myConfig.showBillTitle;
        }
        if (this.myConfig.billDetailConfig !== undefined) {
            this.detailConfig = Object.assign({}, this.detailConfig, this.myConfig.billDetailConfig);
            this.detailVisible = [];
            if (this.detailConfig.items) {
                this.detailConfig.items.forEach((el, index) => {
                    if (el.type === 'EditGridCard') {
                        if (el.dynamicHeight === undefined) {
                            el.dynamicHeight = true;
                        }
                        if (el.addBtnType === undefined) {
                            if (this.myConfig.saveModel === 'part') {
                                el.addBtnType = '3';
                                el.editObjectBefore = this.editObjectBefore;
                            } else {
                                el.addBtnType = '1';
                            }
                        }
                        if (el.height === undefined) {
                            if (el.dynamicHeight !== false) {
                                el.height = 840;
                            } else {
                                el.height = 260;
                            }
                        }
                    }
                    if (el.type === 'FormCardBox') {
                        el.showBtn = false;
                    }
                    if (el.type === 'DetailsBox') {
                        if (el.detailsGroup !== undefined) {
                            el.modeType = 'pop';
                            el.editDetailsGroup = this.editDetailsGroup;
                            let tempObj = {};
                            Object.assign(tempObj, el);
                            tempObj.modeType = 'group';
                            tempObj.editObjectBefore = this.editObjectBefore;
                            tempObj.titleType = this.myConfig.titleType;
                            let tempIndex = this.detailsGroup.findIndex(el2 => el2.code === el.detailsGroup);
                            if (tempIndex > -1) {
                                this.detailsGroup[tempIndex].items.push(tempObj);
                            } else {
                                let obj = {};
                                obj.code = el.detailsGroup;
                                obj.items = [];
                                obj.items.push(tempObj);
                                this.detailsGroup.push(obj);
                            }
                        } else {
                            if (this.myConfig.saveModel === 'part') {
                                el.modeType = 'pop';
                                el.editDetailsGroup = this.editDetailsGroup;
                            }
                        }
                    }
                    if (el.type === 'AppendixBox') {
                        if (this.myConfig.saveModel === 'part') {
                            el.showBtn = true;
                            el.editObjectBefore = this.editObjectBefore;
                        } else {
                            el.showBtn = false;
                        }
                    }
                    el.titleType = this.myConfig.titleType;
                    el.tableSize = 'small';
                    el.showBorder = false;
                    el.hide = true;
                    el.bordered = true;
                    el.disHover = false;
                    el.showCheckBox = false;
                    el.showBorder = false;
                    this.detailVisible.push({refname:el.name,visible:true});
                    this.anchorData.push({id:'#detail_'+index, name:el.title,refname:el.name,visible:true});
                });
            }
        }
        if (this.myConfig.showOperLog) {
            this.anchorData.push({id:'#operlog', name:'操作日志',refname:'operlog',visible:true});
        } 
        if (this.myConfig.billisworkflow && this.myConfig.billisworkflow.startsWith('Y')) {
            this.myConfig.showApprovalLog = true;
            this.anchorData.push({id:'#approvallog', name:'审批日志',refname:'approvallog',visible:true});
        }
        if (this.myConfig.showAnchorLink !== undefined) {
            this.showAnchorLink = this.myConfig.showAnchorLink;
        }
        if (this.showAnchorLink) {
            this.rowGutter = 16;
            if (this.myConfig.anchorCol) {
                this.anchorCol = this.myConfig.anchorCol;
                this.formCol = 24 - Number(this.anchorCol);
            } else {
                this.anchorCol = 4;
                this.formCol = 20;
            }
        } else {
            this.rowGutter = 0;
            this.anchorCol = 0;
            this.formCol = 24;
        }
        if (this.detailsGroup.length > 0) {
            this.showDetailsGroup = true;
            this.curlDetailsGroup = this.detailsGroup[0].code;
        }
        if (this.showMenuToolbar) {
            if (this.myConfig.menuToolbar) {
                this.menuToolbar = this.$Method.copy(this.myConfig.menuToolbar);
            }
            this.menuToolbar.billisworkflow = this.myConfig.billisworkflow;
        }


    },
    updated() {
        this.offsetTop = 50;
    },
    computed:{
        style () {
            let height = this.$Store.state.app.clientHeight - this.myConfig.adjustHeight;
            if (this.showAnchorLink) {
                return  'background:#eee;';
            } else {
                return 'height:' + height + 'px;background:#eee;';
            }
          
        },
        style2 () {
            let height = this.$Store.state.app.clientHeight - this.myConfig.adjustHeight - this.extraHeight - this.outsideHeight;
            if (this.showAnchorLink) {
                return 'overflow-y: auto;min-height:' + height + 'px;background:#eee;';
            } else {
                return 'overflow-y: auto;height:' + height + 'px;background:#eee;';
            }
        }
    },
    methods:{
        doAction (obj) {
            if (obj.name === 'editForm' || obj.name === 'cancelForm' || obj.name === 'editGrid' || obj.name === 'cancelGrid' || obj.name ==='submitData' || obj.name === 'approveData') {
                this[obj.name](obj);
            } else {
                if (obj.name === 'addData') {
                    this.curlEditObject = '';
                    this.setAllBtnReadOnly(false);
                }
                this.$emit('doAction' , obj);
            }
        },
        doRowBtn () {
            if (this.myConfig.rowBtnMethod) {
                let obj = {};
                obj.name = this.myConfig.rowBtnMethod;
                this.$emit('doAction' , obj);
            }
        },
        anchorClick(id) {
            let temp = this.anchorData.find(el => el.id === id);
            if (temp && temp.refname) {
                if (this.$refs[temp.refname] instanceof Array) {
                    if (this.$refs[temp.refname][0]) {
                        if (this.$refs[temp.refname][0].setShowGrid) {
                            this.$refs[temp.refname][0].setShowGrid(true);
                        } else {
                            this.$refs[temp.refname][0].setShowForm(true);
                        }
                       
                    }
                } else {
                    if (this.$refs[temp.refname].setShowGrid) {
                        this.$refs[temp.refname].setShowGrid(true);
                    } else {
                        this.$refs[temp.refname].setShowForm(true);
                    }
                }
            }
        },
        setAllAnchorVisible(value) {
            let data = this.$Method.copy(this.anchorData);
            if (data && data.length > 0) {
                data.forEach(el => {
                    if (el.refname && el.refname !== 'head') {
                        this.setAnchorVisibleCommon(el.refname,value);
                    }
                });
            }
        },
        setAnchorVisible(obj, value) {
            if (obj) {
                if (obj instanceof Array) {
                    obj.forEach(el => {
                        this.setAnchorVisibleCommon(el,value);
                    });
                } else {
                    this.setAnchorVisibleCommon(obj,value);
                }
            }
        },
        setAnchorVisibleCommon(name , value) {
            let index = this.anchorData.findIndex(el2 => el2.refname === name);
            if (index > -1) {
                let temp = Object.assign({}, this.anchorData[index], {visible:value});
                this.anchorData.splice(index ,1, temp);
            }
            if (name === 'operlog') {
                this.operVisible = value;
            } else if (name === 'approvallog') {
                this.approvalVisible = value;
            } else {
                if (name !== 'head') {
                    if (this.detailVisible && this.detailVisible.length > 0) {
                        let indexConfig = this.detailVisible.findIndex(el3 => el3.refname === name);
                        if (indexConfig > -1) {
                            let config = Object.assign({}, this.detailVisible[indexConfig], {visible:value});
                            this.detailVisible.splice(indexConfig ,1, config);
                        }
                    }
                }
            }
        },
        setRowBtnVisible(value) {
            this.rowBtnVisible = value;
        },
        doMenuToolbar () {
            if (this.$refs.menutoolbar) {
                this.$refs.menutoolbar.addBtnObject(this.frontBtn,'front');
            }
        },
        setData(data) {
            if (this.showBillTitle) {
                this.billno = data[this.myConfig.billnoField];
                let billstatus = '[' + data[this.myConfig.billstatusField] + ']';
                if (this.dictData[this.myConfig.billstatusDictkey]) {
                    let temp = this.dictData[this.myConfig.billstatusDictkey].find(el => el.code ===  data[this.myConfig.billstatusField]);
                    billstatus = billstatus + temp.name;
                }
                this.billstatus = billstatus;
            }
            this.$refs.form.setData(data);
            if (data.ph_key && this.$refs.operlog) {
                this.setAnchorVisibleCommon('operlog' ,true);
                this.$refs.operlog.refurbish(data[this.myConfig.operLogKey]);
            }
            if (this.detailConfig.items) {
                this.detailConfig.items.forEach(el => {
                    if (data[el.name]) {
                        if (this.$refs[el.name] && this.$refs[el.name][0]) {
                            if (el.type === 'DetailsBox') {
                                let tempDetailData = this.setDetailsBox(el, data);
                                this.$refs[el.name][0].setData(tempDetailData);
                            } else {
                                if (el.type === 'FormCardBox') {
                                    if (data[el.name].length > 0) {
                                        this.$refs[el.name][0].setData(data[el.name][0]);
                                    } else {
                                        this.$refs[el.name][0].clearData();
                                    }
                                } else {
                                    this.$refs[el.name][0].setData(data[el.name]);
                                }
                            } 
                        }
                    } else {
                        if (this.config.response === el.name) {
                            if (el.type === 'FormCardBox') {
                                let temp = {};
                                if (el.items) {
                                    el.items.forEach(el2 => {
                                        if (el2.name) {
                                            temp[el2.name] = data[el2.name];
                                        }
                                        if (el2.sname) {
                                            temp[el2.sname] = data[el2.sname];
                                        }
                                        if (el2.ename) {
                                            temp[el2.ename] = data[el2.ename];
                                        }
                                        if (el2.textName) {
                                            temp[el2.textName] = data[el2.textName];
                                        }
                                    });
                                }
                                this.$refs[el.name][0].setData(temp);
                            }
                        } else {
                            if (this.$refs[el.name] && this.$refs[el.name][0]) {
                                this.$refs[el.name][0].setData([]);
                            }
                        }
                    }
                });
            }
            if (this.myConfig.showApprovalLog) {
                this.setAnchorVisibleCommon('approvallog' ,true);
                this.$refs.approvallog.setData(data);
            }
            this.$nextTick(() => {
                setTimeout(()=>{
                    this.curlEditObject = '';
                    this.setAllBtnReadOnly(false);
                },250);
            });
        },
        setDetailsBox(el,  data) {
            let form = data[el.name];
            if (el.gridConfig.items && el.gridConfig.items.length > 0 && el.gridName) {
                let gridData = data[el.gridName];
                if (form && form.length > 0) {
                    form.forEach(el2 => {
                        el2[el.gridName] = [];
                        gridData.forEach(el3 => {
                            if (el2[el.uniqueKeys] === el3[el.uniqueKeys]) {
                                el2[el.gridName].push(el3);
                            }
                        });
                    });
                }
            }
            return form;
        },
        getChangeData (detialsname) {
            let data = this.$refs.form.getData();
            for (let pro in data) {
                if (data[pro] instanceof Array) {
                    if (data[pro].length === 0) {
                        delete data[pro];
                    } else {
                        let temp = [];
                        data[pro].forEach(el => {
                            if (el.flag !== undefined) {
                                temp.push(el);
                            }
                        });
                        if (temp.length > 0) {
                            data[pro] = temp;
                        } else {
                            delete data[pro];
                        }
                    }
                }
            }
            if (!data.ph_key) {
                data.flag = 'I';
            } else {
                data.flag = 'U';
            }
            if (this.myConfig.saveModel === 'part') {
                if (!detialsname) {
                    if (this.curlEditObject) {
                        detialsname = this.curlEditObject;
                    } 
                }
            }
            if (this.detailConfig.items) {
                if (detialsname) {
                    let name = [];
                    if (detialsname instanceof Array) {
                        name = detialsname;
                    } else {
                        name.push(detialsname);
                    }
                    name.forEach(el => {
                        let config = this.detailConfig.items.find(el2 => el2.name === el);
                        if (config) {
                            this.getCommonChangeData(data, config);
                        }
                    });
                    this.detailConfig.items.forEach(el => {
                        let index = name.findIndex(el2 => el.name === el2);
                        if (index === -1) {
                            if (el.gridName) {
                                delete data[el.gridName];
                            }
                            delete data[el.name];
                        }
                    });
                } else {
                    this.detailConfig.items.forEach(el => {
                        this.getCommonChangeData(data, el);
                    });
                }
                
            }
            return data;
        },
        getCommonChangeData(data, el) {
            if (this.$refs[el.name] && this.$refs[el.name][0]) {
                if (el.type === 'DetailsBox') {
                    Object.assign(data, this.getDetailsBox(el));
                } else if (el.type === 'FormCardBox') {
                    if (this.config.response === el.name) {
                        Object.assign(data, this.getFormCardBox(el));
                    } else {
                        let temp = this.getFormCardBox(el,true);
                        if (!temp.ph_key) {
                            temp.flag = 'I';
                        } else {
                            temp.flag = 'U';
                        }
                        data[el.name] = [temp];
                    }
                } else {
                    data[el.name] = this.$refs[el.name][0].getChangeData();
                }
            }
        },
        getFormCardBox (el, flag) {
            let data = this.$refs[el.name][0].getData();
            if (flag) {
                return data;
            }
            let obj = {};
            if (el.items) {
                el.items.forEach(el2 => {
                    if (el2.name) {
                        obj[el2.name] = data[el2.name];
                    }
                    if (el2.sname) {
                        obj[el2.sname] = data[el2.sname];
                    }
                    if (el2.ename) {
                        obj[el2.ename] = data[el2.ename];
                    }
                    if (el2.textName) {
                        obj[el2.textName] = data[el2.textName];
                    }
                });
            }
            return obj;
        },
        getDetailsBox(el) {
            let name = el.name;
            if (el.detailsGroup) {
                name = name + '_detailsGroup';
            }
            let form = this.$refs[name][0].getChangeData();
            let obj = {};
            if (el.gridConfig.items && el.gridConfig.items.length > 0 && el.gridName) {
                let gridData = [];
                if (form && form.length > 0) {
                    form.forEach(el2 => {
                        if (el2[el.gridName] && el2[el.gridName].length > 0) {
                            if (el2.flag !== 'D') {
                                el2[el.gridName].forEach(el3 => {
                                    if (el3.flag !== undefined) {
                                        gridData.push(el3);
                                    }
                                });
                            } else {
                                el2[el.gridName].forEach(el3 => {
                                    if (el3.ph_key !== undefined) {
                                        el3.flag = 'D';
                                        gridData.push(el3);
                                    }
                                });
                            }
                        }
                        delete el2[el.gridName];
                    });
                }
                if (gridData.length > 0) {
                    obj[el.gridName] = gridData;
                } else {
                    obj[el.gridName] = [];
                }
            }
            if (form.index) {
                delete form.index;
            }
            obj[el.name] = form;
            return obj;
        },
        getData() {
            let data = this.$refs.form.getData();
            if (this.detailConfig.items) {
                this.detailConfig.items.forEach(el => {
                    if (this.$refs[el.name] && this.$refs[el.name][0]) {
                        if (this.config.response === el.name) {
                            let tempData = this.$refs[el.name][0].getData();
                            let temp = {};
                            if (el.items) {
                                el.items.forEach(el2 => {
                                    if (el2.name) {
                                        temp[el2.name] = tempData[el2.name];
                                    }
                                    if (el2.sname) {
                                        temp[el2.sname] = tempData[el2.sname];
                                    }
                                    if (el2.ename) {
                                        temp[el2.ename] = tempData[el2.ename];
                                    }
                                    if (el2.textName) {
                                        temp[el2.textName] = tempData[el2.textName];
                                    }
                                });
                            }
                            Object.assign(data,temp);
                        } else {
                            data[el.name] = this.$refs[el.name][0].getData();
                        }
                      
                    }
                });
            }
            return data;
        },
        getDetailData(name) {
            let data = [];
            if (this.$refs[name] && this.$refs[name][0]) {
                data = this.$refs[name][0].getData();
            }
            return data;
        },
        setReadOnly(value) {
            this.readOnly = value;
            this.$refs.form.setFormReadOnly(value);
            if (this.detailConfig.items) {
                this.detailConfig.items.forEach(el => {
                    if (this.$refs[el.name] && this.$refs[el.name][0]) {
                        if (el.type === 'FormCardBox') {
                            this.$refs[el.name][0].setFormReadOnly(value);
                        } else {
                            this.$refs[el.name][0].setReadOnly(value); 
                        }
                      
                    }
                });
            }
        },
        isChange (){
            if (this.readOnly) {
                return false;
            }
            let flag = this.$refs.form.isChange();
            if (!flag) {
                if (this.detailConfig.items) {
                    this.detailConfig.items.forEach(el => {
                        if (!flag) {
                            if (this.$refs[el.name] && this.$refs[el.name][0]) {
                                flag = this.$refs[el.name][0].isChange();
                            }
                        }
                    });
                }
            }
            return flag;
        },
        isEdit () {
            let flag = false;
            if (this.detailConfig.items) {
                this.detailConfig.items.some(el => {
                    if (el.type === 'DetailsBox') {
                        if (this.$refs[el.name] && this.$refs[el.name][0]) {
                            if (this.myConfig.modeType === 'part') {
                                if (el.name !== this.curlEditObject) {
                                    flag = this.$refs[el.name][0].isEdit();
                                }
                            } else {
                                flag = this.$refs[el.name][0].isEdit();
                            }
                        }
                    }
                    if (flag) {
                        return true;
                    }
                });
            }
            return flag;
        },
        getMenuToolbar () {
            return this.$refs.menutoolbar;
        },
        clearData() {
            this.billno = '';
            this.billstatus = '';
            this.$refs.form.clearData();
            if (this.$refs.operlog) {
                this.$refs.operlog.clearData();
                this.setAnchorVisibleCommon('operlog' ,false);
            }
            if (this.$refs.approvallog) {
                this.$refs.approvallog.clearData();
                this.setAnchorVisibleCommon('approvallog' ,false);
            }
            if (this.detailConfig.items) {
                this.detailConfig.items.forEach(el => {
                    if (this.$refs[el.name] && this.$refs[el.name][0]) {
                        this.$refs[el.name][0].clearData();
                    }
                });
            }
        },
        checkValidate () {
            let flag = false;
            this.$refs.form.checkValidate();
            flag = this.$refs.form.isError();
            if (!flag) {
                if (this.detailConfig.items) {
                    if (this.myConfig.saveModel === 'part') {
                        if (this.curlEditObject) {
                            let index = this.detailConfig.items.findIndex(el => el.name === this.curlEditObject);
                            if (index > -1) {
                                if (this.detailVisible[index].visible) {
                                    flag = this.checkCommonValidate(this.detailConfig.items[index]);
                                }
                            }
                        } else {
                            this.detailConfig.items.some((el,index) => {
                                if (!flag) {
                                    if (this.detailVisible[index].visible) {
                                        flag = this.checkCommonValidate(el);
                                    }
                                    if (flag) {
                                        return true;
                                    }
                                }
                            });
                        }
                    } else {
                        this.detailConfig.items.some((el,index) => {
                            if (!flag) {
                                if (this.detailVisible[index].visible) {
                                    flag = this.checkCommonValidate(el);
                                }
                                if (flag) {
                                    return true;
                                }
                            }
                        });
                    }
                    
                }
            }
            return flag;
        },
        checkCommonValidate(el) {
            let flag = false;
            if (this.$refs[el.name] && this.$refs[el.name][0] && this.$refs[el.name][0].checkValidate) {
                if (el.type === 'FormCardBox') {
                    this.$refs[el.name][0].checkValidate();
                    flag = this.$refs[el.name][0].isError();
                } else {
                    flag = this.$refs[el.name][0].checkValidate();
                }
            }
            return flag;
            
        },
        getForm (name) {
            if (this.multipleForm) {
                return this.$refs.form.getForm(name);
            } else {
                return this.$refs.form;
            }
        },
        getDetail(name) {
            if (this.$refs[name] && this.$refs[name][0]) {
                let index = this.detailConfig.items.findIndex(el => el.name === name);
                if (index > -1) {
                    if (this.detailConfig.items[index].type === 'DetailsBox') {
                        if (this.detailConfig.items[index].detailsGroup !== undefined) {
                            return this.$refs[name + '_detailsGroup'][0];
                        }
                    }
                }
                return this.$refs[name][0];
            } else {
                return null;
            }
        },
        getDetailTitle(name) {
            let index = this.anchorData.findIndex(el => el.refname === name);
            if (index > -1) {
                return this.anchorData[index].name;
            }
            return '';
        },
        editDetailsGroup(value) {
            let index  = this.detailsGroup.findIndex(el => el.code === value);
            if (index > -1) {
                let flag = true;
                this.detailsGroup[index].items.some(el =>{
                    if (el.editObjectBefore) {
                        flag = el.editObjectBefore();
                    }
                    if (!flag) {
                        return true;
                    }
                });
                if (flag) {
                    this.curlDetailsGroup = value;
                    this.detailsGroup[index].items.forEach(el => {
                        if (this.$refs[el.name +'_detailsGroup'] && this.$refs[el.name +'_detailsGroup'][0]) {
                            let data  = this.$refs[el.name][0].getData();
                            this.$refs[el.name +'_detailsGroup'][0].setData(data);
                            this.$refs[el.name +'_detailsGroup'][0].setReadOnly(false);
                        }
                    });
                    this.$nextTick(() => {
                        this.editFlag = true;
                    });
                }
            }
        },
        editObjectBefore(name) {
            if (this.curlEditObject) {
                if (name && name === this.curlEditObject) {
                    return true;
                } else {
                    this.alert('存在数据未保存');
                    return false;
                }
            }
            return true;
        },
        editForm(obj) {
            this.curlEditObject = obj.formname;
            this.setAllBtnReadOnly(true);
            this.setBtnReadOnly (this.curlEditObject, false);
            this.setMenuToolbar(true);
        },
        cancelForm() {
            this.curlEditObject = '';
            this.setAllBtnReadOnly(false);
            this.setMenuToolbar(false);
        },
        editGrid(obj) {
            this.curlEditObject = obj.gridname;
            this.setAllBtnReadOnly(true);
            this.setBtnReadOnly (this.curlEditObject, false);
            this.setMenuToolbar(true);
        },
        cancelGrid() {
            this.curlEditObject = '';
            this.setAllBtnReadOnly(false);
            this.setMenuToolbar(false);
        },
        setAllBtnReadOnly(value) {
            this.myConfig.formsConfig.items.forEach(el => {
                this.getForm(el.name).setBtnReadOnly(value);
            });
            if (this.detailConfig.items) {
                this.detailConfig.items.forEach(el => {
                    if (this.$refs[el.name] && this.$refs[el.name][0]) {
                        if (this.config.response !== el.name) {
                            this.$refs[el.name][0].setBtnReadOnly(value); 
                        }
                    }
                });
            }
        },
        setBtnReadOnly(name, value) {
            this.myConfig.formsConfig.items.forEach(el => {
                if (el.name === name) {
                    this.getForm(el.name).setBtnReadOnly(value);
                }
            });
            if (this.detailConfig.items) {
                this.detailConfig.items.forEach(el => {
                    if (this.$refs[el.name] && this.$refs[el.name][0]) {
                        if (this.config.response !== el.name && el.name === name) {
                            this.$refs[el.name][0].setBtnReadOnly(value); 
                        }
                    }
                });
            }
        },
        setMenuToolbar(value) {
            if (this.showMenuToolbar && this.myConfig.saveModel === 'part') {
                this.getMenuToolbar().setAllReadOnly(value);
                this.getMenuToolbar().setReadOnly('saveData', !value);
            }
        },
        saveDetailsGroup() {
            let index = this.detailsGroup.findIndex(el => el.code === this.curlDetailsGroup);
            if (index > -1) {
                let flag = false;
                this.detailsGroup[index].items.some(el => {
                    if (this.$refs[el.name +'_detailsGroup'] && this.$refs[el.name +'_detailsGroup'][0]) {
                        flag = this.$refs[el.name +'_detailsGroup'][0].checkValidate();
                        if (flag) {
                            return true;
                        }
                    }
                });
                if (flag) {
                    return;
                }
            }
           
            let obj = {};
            obj.name = 'saveDetails';
            obj.detailsname = [];
            this.detailsGroup[index].items.forEach(el => {
                obj.detailsname.push(el.name);
            });
            this.editFlag = false;
            this.$emit('doAction', obj);
        },
        cancelDetailsGroup() {
            this.editFlag = false;
        },
        setEditVisible (value) {
            this.$refs.form.setShowBtn(value);
            if (this.detailConfig.items) {
                this.detailConfig.items.forEach(el => {
                    if (this.$refs[el.name] && this.$refs[el.name][0]) {
                        if (el.type === 'FormCardBox') {
                            if (this.config.response !== el.name) {
                                this.$refs[el.name][0].setShowBtn(value);
                            }
                        } else if (el.type === 'EditGridCard'){
                            this.$refs[el.name][0].setBtnType('3');
                            this.$refs[el.name][0].setShowBtn(value);
                        } else {
                            this.$refs[el.name][0].setShowBtn(value);
                        }
                    }
                });
            }
        },
        showApprovalLog () {
            if (this.$refs.approvallog && this.$refs.approvallog.show) {
                this.$refs.approvallog.show();
            } 
        },
        submitData() {
            if (this.$refs.approvallog && this.$refs.approvallog.show) {
                this.$refs.approvallog.submit();
            } 
        },
        approveData() {
            this.showApprovalLog();
        },
        setExtraHeight () {
            let height = 0;
            if (this.$refs.toolbar) {
                height = this.$refs.toolbar.offsetHeight;
            }
            if (this.$refs.title) {
                height = height + this.$refs.title.offsetHeight;
            }
            this.extraHeight = height;
        },
        setOutsideHeight(value) {
            this.outsideHeight = value;
        }
    },
    props:{
        config: {
            type:Object,
            default:null
        },
        dictData: {
            type: Object,
            default: () => {
                return {};      
            }
        },
        moduleMethod:{
            type:Array,
            default: () => {
                return [];      
            }
        },
        billmoduleid:{
            type:String,
            default:''
        }
    },
    mounted () {
        this.observer = elementResizeDetectorMaker();
        this.observer.listenTo(this.$refs.toolbar, this.setExtraHeight);
        this.observer.listenTo(this.$refs.title, this.setExtraHeight);
        if(this.showMenuToolbar) {
            this.doMenuToolbar();
        }
    },
    beforeDestroy() {
        this.observer.removeListener(this.$refs.toolbar, this.setExtraHeight);
        this.observer.removeListener(this.$refs.title, this.setExtraHeight);
    }
};
</script>




// WEBPACK FOOTER //
// src/components/layouttemplate/billdetailform.vue